import { difference } from 'lodash';
import { useCallback } from 'react';
import { useAirportsWidgetConfig } from '../../../../../components/SearchForm/components/AirportsWidget/hooks/useAirportsWidgetConfig.js';
export const useAirportsWidgetState = ({
  value,
  airports
}) => {
  const {
    retrieveCodes,
    retrieveSubRegions,
    retrieveRegions,
    retrieveAllCodes
  } = useAirportsWidgetConfig({
    airports
  });
  const isChecked = useCallback(code => {
    const codes = retrieveCodes(code);
    if (codes) {
      return value.filter(code => codes.includes(code)).length === codes.length;
    }
    return value.includes(code);
  }, [retrieveCodes, value]);
  const retrieveCheckedRegions = useCallback(() => {
    const regions = retrieveRegions();
    const isCorrectRegion = codes => value.filter(code => codes?.includes(code)).length === codes?.length;
    return regions.reduce((accumulator, region) => {
      const codes = retrieveCodes(region);
      if (isCorrectRegion(codes)) {
        return [...accumulator, {
          region
        }];
      }
      const subRegions = retrieveSubRegions(region);
      subRegions.forEach(subRegion => {
        const codes = retrieveCodes(subRegion);
        if (isCorrectRegion(codes)) {
          accumulator = [...accumulator, {
            region,
            subRegion
          }];
        }
      });
      return accumulator;
    }, []);
  }, [retrieveCodes, retrieveSubRegions, retrieveRegions, value]);
  const isAllChecked = useCallback(() => {
    const codes = retrieveAllCodes();
    return value.filter(code => codes.includes(code)).length === codes.length && codes.length === value.length;
  }, [retrieveAllCodes, value]);
  const retrieveExtraCodes = useCallback(regions => {
    return difference(value, regions.reduce((accumulator, {
      region,
      subRegion
    }) => {
      return subRegion ? [...accumulator, ...(retrieveCodes(subRegion) || [])] : [...accumulator, ...(retrieveCodes(region) || [])];
    }, []));
  }, [retrieveCodes, value]);
  const retrieveCheckedCount = useCallback(() => value.length, [value]);
  const retrieveSingleCheckedCode = useCallback(() => {
    if (value.length === 1) {
      return value[0];
    }
  }, [value]);
  return {
    isChecked,
    retrieveCheckedRegions,
    retrieveExtraCodes,
    isAllChecked,
    retrieveCheckedCount,
    retrieveSingleCheckedCode
  };
};